import React from 'react';
import { HomeContainer, ViewerContainer } from 'containers';
import { Header } from 'components/Header';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import styled from 'styled-components';
import { history } from 'store';

const Container = styled.div`
  text-align: center;
  position: relative;
  height: 100vh;
  overflow: hidden;
`;

function Routes() {
  return (
    <ConnectedRouter history={history}>
      <Container>
        <Header />
        <Route exact path="/" component={HomeContainer} />
        <Route
          exact
          path="/:projectName/:modelId/:revisionId/:sceneId"
          component={ViewerContainer}
        />
      </Container>
    </ConnectedRouter>
  );
}

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js